export const ROUTE_NAMES = {
  IFRAME: 'accounting-iframe'
}

const ROUTES = {
  [ROUTE_NAMES.IFRAME]: {
    name: ROUTE_NAMES.IFRAME,
    path: 'accounting'
  }
}

export default [
  {
    name: ROUTES[ROUTE_NAMES.IFRAME].name,
    path: ROUTES[ROUTE_NAMES.IFRAME].path,
    component: (resolve) => require(['./views/iframe'], resolve)
  }
]
